import React from "react";
import {Link} from "react-router-dom";
import StarRating from "./star-rating";
import HelperService from "../services/helper-service";
import {CourseDifficulty, Sweatmeter} from "../utils/constants";

export default function CourseCell({course, link=null, linkReplace="CID", callback = null, ...props}) {

    const RatingBadge = function () {
        return <>{course?.rating > 0 && <div className="position-absolute bottom-0 p-2 m-2"><StarRating rating={course?.rating} count={course?.ratingsCount} /></div>}</>
    }

    const CourseCellCard = function ({course, ...props}) {
        return <div className="card clickable mb-4 rounded-3 overflow-hidden hover-cell-effect" onClick={callback ? () => callback(course) : undefined}>
            <div className="position-relative">
                <img alt='' src={course?.cover} className="img-fit w-100" style={{height: "200px", animation: "fadeIn 0.5s"}}/>
                <div className="position-absolute bottom-0 p-2 bg-dark-gradient" style={{height: "50px"}}></div>
                <RatingBadge />
            </div>
            <div className="card-body">
                <h6>{course?.name}</h6>
                <div className="text-secondary fs-7 mb-1 text-fadeout" style={{height: '60px', maxHeight: '60px'}}>{course?.info}</div>
                <div className="text-secondary fs-7 mb-1 d-flex gap-3">
                    {course?.sweatmeter &&
                        <div className="d-flex align-items-center">
                            <span className="mdi mdi-water-outline fs-6"></span>  {HelperService.getObjByKey(Object.values(Sweatmeter), 'val', course?.sweatmeter).label}
                        </div>
                    }
                    {course?.difficulty &&
                        <div className="d-flex align-items-center">
                            <span className="mdi mdi-arm-flex-outline fs-6"></span> {HelperService.getObjByKey(Object.values(CourseDifficulty), 'val', course?.difficulty).label}
                        </div>
                    }
                </div>
            </div>
        </div>
    }

    return (<>
        {link && course?.id && <Link className="text-decoration-none" to={link.replace(linkReplace, course?.id)}><CourseCellCard /></Link>}
        {(!link || !course?.id) && <><CourseCellCard course={course} /></>}
    </>);
}
